import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-486f4538"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-container"
};
var _hoisted_2 = {
  class: "user-contest-table-box"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  var _component_ContestTable = _resolveComponent("ContestTable");
  var _component_a_empty = _resolveComponent("a-empty");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [((_a = _ctx.userExamService.userExamList) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_openBlock(), _createBlock(_component_ContestTable, {
    key: 0,
    list: _ctx.userExamService.userExamList
  }, null, 8, ["list"])) : _ctx.userExamService.total >= 0 ? (_openBlock(), _createBlock(_component_a_empty, {
    key: "key-empty",
    description: _ctx.isNocFlag ? '还未参加比赛' : '还未参加活动',
    style: {
      "margin": "100px 0",
      "font-size": "14px",
      "color": "#8f96a3"
    },
    image: _ctx.emptyImage,
    imageStyle: {
      height: '185px'
    }
  }, null, 8, ["description", "image"])) : _createCommentVNode("", true)])])]);
}